// extracted by mini-css-extract-plugin
export default {"root":"QualityCheckTable_root__4UNPy","row":"QualityCheckTable_row__QP0oE"};